/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsListAodRulesQueryResponse, AuditReportsListAodRulesQueryParams, AuditReportsListAodRules401, AuditReportsListAodRules403 } from "../models/AuditReportsListAodRules";

export function getAuditReportsListAodRulesUrl() {
  const res = { method: 'GET', url: `/audit-reports/v1/aod-rules` as const }
  return res
}

/**
 * @summary Retrieve multiple AodRules
 * {@link /audit-reports/v1/aod-rules}
 */
export async function auditReportsListAodRules(params?: AuditReportsListAodRulesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsListAodRulesQueryResponse, ResponseErrorConfig<AuditReportsListAodRules401 | AuditReportsListAodRules403>, unknown>({ method : "GET", url : getAuditReportsListAodRulesUrl().url.toString(), params, ... requestConfig })
  return res.data
}